import _ from 'underscore';

export default class UserOfferRequestItems {
  constructor($scope, OfferRequestService, OfferRequestItemService, PaginationService) {
    $scope.quick_search = function() {
      window.filter_table('table#items', $scope.query);
    };

    $scope.get_offer_request_items = function() {
      $scope.searching = true;
      OfferRequestService.find_offer_request_items($scope.filter).success(function(data) {
        $scope.offer_requests = data.offer_requests;
        $scope.pagination = PaginationService.get_pagination(data.pagination);
        $scope.searching = false;
      });
    };

    $scope.get_page_data = function(page) {
      $scope.filter.page = page;
      $scope.get_offer_request_items();
    };

    $scope.init_filters = function() {
      $scope.filter = {
        page: 1,
        per_page: 10,
        supplier_id: null,
        buyer_id: null,
        status: window.item_statuses
      };
    };

    $scope.get_offer_request_status_title = function(status) {
      return _.findWhere($scope.offer_request_statuses, {
        id: status
      }).title;
    };

    $scope.get_item_status_title = function(status) {
      return _.findWhere($scope.item_statuses, {
        id: status
      }).title;
    };

    $scope.get_fields = function(fields) {
      return _.filter(fields, function(f) {
        return $scope.item_view === 1 || f.standard !== false;
      });
    };

    $scope.get_request_fields = function(offer_request) {
      return _.filter(offer_request.request_fields, function(f) {
        return $scope.item_view === 1 || f.standard !== false;
      });
    };

    /*function price_incoterm_match(offer_request, request_field) {
      if (!request_field.is_price || !offer_request.delivery_term_id)
        return true;
      else if (request_field.is_price)
        return request_field.name === offer_request.delivery_term;
    }*/

    $scope.item_views = [
      {
        id: 0,
        title: 'Standard View'
      },
      {
        id: 1,
        title: 'Full View'
      }
    ];

    $scope.init = function() {
      $scope.init_filters();
      if (window.user_type == 'Buyer')
        $scope.filter.buyer_id = window.user_id;
      else
        $scope.filter.supplier_id = window.user_id;
      $scope.offer_request_statuses = OfferRequestService.get_status_options();
      $scope.item_statuses = OfferRequestItemService.get_status_options();
      $scope.get_offer_request_items();
      $scope.item_view = 0;
      $scope._ = _;
    };

    $scope.init();
  }
}

UserOfferRequestItems.$inject = ['$scope', 'OfferRequestService', 'OfferRequestItemService', 'PaginationService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/user-offer-request-items.ctrl.js